import { render, staticRenderFns } from "./indexProduct.vue?vue&type=template&id=7f541c6e"
import script from "./indexProduct.vue?vue&type=script&lang=js"
export * from "./indexProduct.vue?vue&type=script&lang=js"
import style0 from "./indexProduct.vue?vue&type=style&index=0&id=7f541c6e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f541c6e')) {
      api.createRecord('7f541c6e', component.options)
    } else {
      api.reload('7f541c6e', component.options)
    }
    module.hot.accept("./indexProduct.vue?vue&type=template&id=7f541c6e", function () {
      api.rerender('7f541c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/indexProduct.vue"
export default component.exports